import {
  ClipboardDocumentListIcon,
  ChatBubbleLeftRightIcon,
  ForwardIcon,
  ScaleIcon,
  TrophyIcon,
  ChartBarSquareIcon,
  BellIcon,
  CalendarIcon,
  CalendarDaysIcon,
  PencilSquareIcon,
  GiftIcon,
  DocumentTextIcon,
  ChatBubbleOvalLeftIcon,
  HandThumbUpIcon,
  ArrowTrendingUpIcon,
  LightBulbIcon,
  WrenchScrewdriverIcon,
  ClockIcon,
  VideoCameraIcon,
  FlagIcon,
  ShoppingBagIcon,
  EnvelopeIcon,
  ArrowPathRoundedSquareIcon
} from '@heroicons/vue/24/outline'
import type { Component } from 'vue'

export const MODULE_ICONS: Record<string, Component> = {
  goals: FlagIcon,
  todo: ClipboardDocumentListIcon,
  schedule: CalendarIcon,
  chat: ChatBubbleLeftRightIcon,
  running: ForwardIcon,
  'body-metrics': ScaleIcon,
  strength: TrophyIcon,
  'health-data': ChartBarSquareIcon,
  notifications: BellIcon,
  calendar: CalendarDaysIcon,
  meeting: VideoCameraIcon,
  diary: PencilSquareIcon,
  memo: DocumentTextIcon,
  anniversaries: GiftIcon,
  comments: ChatBubbleOvalLeftIcon,
  votes: HandThumbUpIcon,
  growth: ArrowTrendingUpIcon,
  suggestions: LightBulbIcon,
  improvements: WrenchScrewdriverIcon,
  timer: ClockIcon,
  packing: ShoppingBagIcon,
  mailbox: EnvelopeIcon,
  review: ArrowPathRoundedSquareIcon,
  'wechat-export': ChatBubbleLeftRightIcon
}

export function getModuleIcon(module: string): Component | undefined {
  return MODULE_ICONS[module]
}
